module.exports = __webpack_public_path__ + "static/media/yax.be79cc50.png";